import { useState } from "react";
import { DashboardLayout } from "@/components/Dashboard/DashboardLayout";
import { ChartCard } from "@/components/Dashboard/ChartCard";
import { useLanguage } from "@/contexts/LanguageContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Filter } from "lucide-react";
import { useMetricsHistory } from "@/hooks/useMetricsHistory";

const Analytics = () => {
  const { t } = useLanguage();
  const [areaFilter, setAreaFilter] = useState<string>("all");
  const { history, loading } = useMetricsHistory(areaFilter);

  // Transform history data for charts
  const performanceData = history.map((point, index) => ({
    name: `P${index + 1}`,
    value: point.inProgressProcesses,
  }));

  const activeOperatorsData = history.map((point, index) => ({
    name: `P${index + 1}`,
    value: point.activeOperators,
  }));
  
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold text-foreground">{t.analytics.title}</h2>
            <p className="text-muted-foreground mt-1">
              {t.analytics.subtitle}
            </p>
          </div>
          <Select value={areaFilter} onValueChange={setAreaFilter}>
            <SelectTrigger className="w-[200px]">
              <Filter className="w-4 h-4 mr-2" />
              <SelectValue placeholder={t.filters?.selectArea || "Filtrar por área"} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t.filters?.allAreas || "Todas las áreas"}</SelectItem>
              <SelectItem value="corte_plotter">{t.auth.areas.corte_plotter}</SelectItem>
              <SelectItem value="laminador">{t.auth.areas.laminador}</SelectItem>
              <SelectItem value="taller">{t.auth.areas.taller}</SelectItem>
              <SelectItem value="generico">{t.auth.areas.generico}</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {loading ? (
          <div className="text-center text-muted-foreground py-8">
            {t.common?.loading || "Cargando..."}
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <ChartCard 
              title={t.analytics.performanceTrends} 
              data={performanceData.length > 0 ? performanceData : [{ name: "Sin datos", value: 0 }]} 
              type="area" 
            />
            <ChartCard 
              title={t.analytics.revenueOverview} 
              data={activeOperatorsData.length > 0 ? activeOperatorsData : [{ name: "Sin datos", value: 0 }]} 
              type="line" 
            />
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Analytics;
